import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { RoleService } from '../services/role.service';

/**
 * Guard factory that restricts route access based on minimum role level.
 *
 * Role hierarchy: collector < banker < admin = owner
 *
 * If the user's role is below the required minimum:
 *   - Collectors are redirected to /record-donation
 *   - Everyone else is redirected to /dashboard
 *
 * Usage in routes:
 *   { path: 'analytics', canActivate: [roleGuard('banker')] }
 *   { path: 'settings',  canActivate: [roleGuard('admin')]  }
 */
export function roleGuard(minRole: string): CanActivateFn {
  return () => {
    const roleService = inject(RoleService);
    if (roleService.hasMinRole(minRole)) {
      return true;
    }
    const router = inject(Router);
    return router.createUrlTree([
      roleService.isCollector() ? '/record-donation' : '/dashboard',
    ]);
  };
}
